import React, { useState } from 'react';
import styles from './IngresoPorDNI.module.css';

const IngresoPorDNI = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleHabilitarIngresos = () => {
    window.open('/dni-login-modal', '_blank');
  };

  const handleHistorial = () => {
    window.open('/historial-ingresos', '_blank');
  };

  return (
    <div className={styles.container}>
      <h2>Ingreso al Gimnasio</h2>
      <div className={styles.buttonGroup}>
        <button className={styles.button} onClick={handleHistorial}>Historial de ingresos</button>
        <button className={styles.button} onClick={handleHabilitarIngresos}>Habilitar ingresos</button>
      </div>
    </div>
  );
};

export default IngresoPorDNI;